module.exports = __webpack_public_path__ + "static/media/confirmDisabled.8b44a4a8.svg";